"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var search_1 = __importDefault(require("./queries/search"));
var suggestions_1 = __importDefault(require("./queries/suggestions"));
var api_1 = require("../../utils/api");
var config_1 = __importStar(require("../../config"));
var constants_1 = require("./constants");
exports.query = function (searchQuery) { return toolkit_1.createAction(constants_1.SET_SEARCH_QUERY)(searchQuery); };
exports.search = function (term) {
    return api_1.createApiAction(constants_1.SEARCH, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: search_1.default,
            variables: { term: "" + term },
        },
        authenticated: true,
        graphQL: true,
        onRequest: function (dispatch) {
            dispatch(exports.query(term));
        },
    });
};
exports.suggestions = function (term) {
    return api_1.createApiAction(constants_1.SUGGESTIONS, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: suggestions_1.default,
            variables: { term: "" + term },
        },
        authenticated: true,
        graphQL: true,
        onRequest: function (dispatch) {
            dispatch(exports.query(term));
        },
    });
};
/**  TODO This endpoint is removed from backend api due to incorrect data returned by skylark apis.
 *  This functionality is descoped temporarily after discussing with David. The code is just kept in place
 *  as a placeholder for future implementation
 */
exports.fetchPopular = function (railUrl) {
    return api_1.createApiAction(constants_1.FETCH_POPULAR, {
        baseURL: config_1.default.EXP_API_URL,
        path: '/rails',
        params: { url: railUrl },
        authenticated: true,
    });
};
/**  TODO This endpoint is removed from backend api due to incorrect data returned by skylark apis.
 *  This functionality is descoped temporarily after discussing with David. The code is just kept in place
 *  as a placeholder for future implementation
 */
exports.fetchSimilar = function (searchQuery) {
    return api_1.createApiAction(constants_1.FETCH_SIMILAR, {
        baseURL: config_1.default.EXP_API_URL,
        path: '/search',
        params: { query: searchQuery },
        onlyLatest: true,
        authenticated: true,
    });
};
//# sourceMappingURL=actions.js.map